<template>
  <svg
    :width="width"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.4 0C24.0896 0 24.7509 0.273928 25.2385 0.761522C25.7261 1.24912 26 1.91044 26 2.6V18.2C26 18.8896 25.7261 19.5509 25.2385 20.0385C24.7509 20.5261 24.0896 20.8 23.4 20.8H5.2L0 26V2.6C0 1.157 1.17 0 2.6 0H23.4ZM2.6 2.6V19.721L4.121 18.2H23.4V2.6H2.6Z"
      :fill="iconColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.6 14.3V11.18L19.5 14.3V6.5L15.6 9.62V6.5H7.8V14.3H15.6ZM13.13 11.83V8.97H10.27V11.83H13.13Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
export default Vue.extend({
  name: "OnlineEventIcon",
  props: {
    color: String,
    width: { type: Number, default: 31 },
  },
  computed: {
    iconColor: function () {
      let color = this.color
        ? this.color
        : this.$vuetify.theme.themes.light.textColor
      return color
    },
  },
})
</script>
